import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { ClientExperienceNoteOverride } from 'Resources/Note';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import MetaCollectionFormInline from 'Components/UI/Meta/MetaForm/MetaCollectionFormInline';
import fr from 'facet-rest';
import { useAccomplishmentsTabContext } from 'Hooks/useRefreshEvent';

function Notes({ classes, resource }) {
  const [noteCollection, setNoteCollection] = React.useState();

  async function fetchNote() {
    const link = resource?.relationship(fr.relationships.accomplishmentNotes.name).link('related');
    if (!link) {
      return;
    }
    const collection = await link?.get(
      { metaOverrideSet: ClientExperienceNoteOverride },
    ) ?? null;

    if (collection?.resources().list().length === 0) {
      collection.create({
        addToCollection: true,
        metaOverrideSet: ClientExperienceNoteOverride,
      });
    }
    setNoteCollection(collection);

    const [nextNote] = collection;
    nextNote.attr('noteType', 'accomplishments');
  }

  React.useEffect(() => {
    if (resource && resource.relationship(fr.relationships.accomplishmentNotes.name)) {
      fetchNote().catch(e => displayErrorMessage(e, 'Failed to fetch note'));
    }
  }, [resource?.id()]);


  useAccomplishmentsTabContext(() => {
    fetchNote();
  }, []);

  return (noteCollection ? <MetaCollectionFormInline
    className={classes.noteForm}
    collection={noteCollection}
    FormProps={{ autoSave: true }}
  /> : null);
}

Notes.propTypes = {
  classes: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
};

export default withStyles(theme => ({
  root: {
    width: '100%',
    gap: '16px',
  },
  notes: {
    padding: theme.spacing(2),
    borderRadius: theme.radius.sm,
  },
  noteForm: {
    flexGrow: '1',
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    '& > h3': {
      fontWeight: theme.typography.fontWeightBold,
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gridArea: 'button',
  },
  button: {
    maxWidth: theme.dimensions.sm,
  },
}))(Notes);
